import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DatePipe } from '@angular/common';
import { Config } from 'src/app/app-constant';
import { HttpService } from 'src/app/service/http/http.service';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { LoaderService } from 'src/app/service/loader/loader.service';
import { SharedService } from 'src/app/service/shared/shared.service';
import { saveAs } from 'file-saver';
import { environment } from 'src/environments/environment';
import { MobileResponsiveService } from 'src/app/services/mobile-view/mobile-responsive.service';

@Component({
  selector: 'app-competecny-dashboard-details-popup',
  templateUrl: './competecny-dashboard-details-popup.component.html',
  styleUrls: ['./competecny-dashboard-details-popup.component.scss'],
})
export class CompetecnyDashboardDetailsPopupComponent implements OnInit {

  popupName:any;
  selectedYear:any;
  loggedInUserCompanyID:any;
  competencyemployee:any=[];
  setupGradeBrand:any;
  publishedCompetencyCount: any;
  unPublishedCompetencyCount: any;
  loggedInUserRole:any;
  isToggleOn:boolean=false;
  constructor(@Inject(MAT_DIALOG_DATA) public dialogData: any,
    private httpService: HttpService,
    private config: Config,
    public dialogRef: MatDialogRef<CompetecnyDashboardDetailsPopupComponent>,
    private fb: FormBuilder,
    public sharedService: SharedService,
    private encryptionService: EncryptionService,
    private datePipe: DatePipe,
    private loader: LoaderService,
    public dialog: MatDialog, public mobileResponsiveService: MobileResponsiveService) { }

  ngOnInit() { 
    this.popupName = this.dialogData.popupName;
    this.selectedYear = this.dialogData.year;
    this.setupGradeBrand = this.dialogData.setupGradeBrand;
    this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));
    this.loggedInUserRole = sessionStorage.getItem('loggedInUserRole');
    if (this.loggedInUserRole) {
      this.loggedInUserRole = this.encryptionService.decryptData(this.loggedInUserRole);
    }
    if(this.popupName == 'Competency Set'){
      this.publishedUnpublishedCompetenciesDashboard();
    }
    if(this.popupName == 'Evaluated by Manager'){
      this.evaluatedAndNonEvaluatedCompetenciesDashboard();
    }
  }
  onChangeSwitch(event: any) {
    this.isToggleOn = event?.checked;
    if (event?.checked == true) {
      if(this.popupName == 'Competency Set'){
        this.publishedUnpublishedCompetenciesDashboard();
      }
      if(this.popupName == 'Evaluated by Manager'){
        this.evaluatedAndNonEvaluatedCompetenciesDashboard();
      }
    }else{
      if(this.popupName == 'Competency Set'){
        this.publishedUnpublishedCompetenciesDashboard();
      }
      if(this.popupName == 'Evaluated by Manager'){
        this.evaluatedAndNonEvaluatedCompetenciesDashboard();
      }
    }
  }
  evaluatedAndNonEvaluatedCompetenciesDashboard() {
    const request = {
      "companyId": this.loggedInUserCompanyID,
      "loggedInUserRole":this.loggedInUserRole,
      "completeIncomplete": this.isToggleOn,
      "yearRange": this.selectedYear,
    }
    console.log( "toggle on ....",this.isToggleOn);
    
    this.httpService.callPostService(this.config.evaluatedAndNonEvaluatedCompetenciesDashboard, request).subscribe((result: any) => {
      console.log("Popup Request:", request);

      // this.competencyemployee = result.data.competencies;
      this.competencyemployee = result.data.competencies.filter((item: { evaluatedDate: string | null; }) => {
        return this.isToggleOn
          ? item.evaluatedDate !== null && item.evaluatedDate !== '' // Evaluated
          : !item.evaluatedDate || item.evaluatedDate === '';       // Not Evaluated
      });
      
      console.log("comptency Employee..",  this.competencyemployee);
      
      this.publishedCompetencyCount = result.data.evalautedCount;
      console.log("Published....",  this.publishedCompetencyCount );
      
      this.unPublishedCompetencyCount = result.data.nonEvalautedCount;
      console.log("Non Published....",  this.publishedCompetencyCount );
      
    })
  }
  publishedUnpublishedCompetenciesDashboard() {
    const request = {
      "companyId": this.loggedInUserCompanyID,
      "loggedInUserRole":this.loggedInUserRole,
      "completeIncomplete": this.isToggleOn,
      "yearRange": this.selectedYear,
    }
    this.httpService.callPostService(this.config.publishedUnpublishedCompetenciesDashboard, request).subscribe((result: any) => {
      this.competencyemployee = result?.data?.competencies?.map((item: any) => ({
        ...item,
        formattedPublishedOn: this.datePipe?.transform(item.publishedOn, 'dd-MM-yyyy | hh:mm a'),
        formattedCreatedAt: this.datePipe?.transform(item.createdAt, 'dd-MM-yyyy | hh:mm a'),
        formattedLastModifiedOn: this.datePipe?.transform(item.lastModifiedOn, 'dd-MM-yyyy | hh:mm a'),
        published: item.published
      }));
      
      this.publishedCompetencyCount = result?.data?.publishedCompetencyCount;
      this.unPublishedCompetencyCount = result?.data?.unPublishedCompetencyCount;
    })
  }
  getTotalWeight(item: any): number {
    return item.competencyMasterlist?.reduce((acc: number, comp: any) =>
      acc + (comp.weightageNo || 0), 0);
  }
  exportDashboardListExcel() {
    const request = {
      "companyId": this.loggedInUserCompanyID,
      "completeIncomplete": this.isToggleOn,
      "yearRange": this.selectedYear,
      "loggedInUserRole": this.loggedInUserRole
    }
    if(this.popupName == 'Competency Set'){
      this.httpService.callPostService(this.config.downloadPublishedUnpublishedCompetenciesDashboard, request).subscribe((data: any) => {
        console.log("competency set...",data);
        
        if(data?.data!=null){
          var fileName = data?.data?.split(environment.downloadURL)
          saveAs(data?.data, fileName[1]); 
        }
      })    
    }
 
  if (this.popupName == 'Evaluated by Manager') {
    this.httpService.callPostService(this.config.downloadEvaluatedAndNonEvaluatedCompetenciesDashboard, request)
      .subscribe((data: any) => {
        if (data?.data) {
          let filtered = this.competencyemployee.filter((item: { evaluatedDate: string | null }) => {
            return this.isToggleOn
              ? item.evaluatedDate !== null && item.evaluatedDate !== '' // Evaluated
              : !item.evaluatedDate || item.evaluatedDate === '';       // Not Evaluated
          });
          console.log("Filtered data for Excel...", filtered);   
          filtered = filtered.map((item: any) => ({
            ...item,
            evaluatedDate: item.evaluatedDate
              ? this.datePipe.transform(item.evaluatedDate, 'dd-MM-yyyy | hh:mm a')
              : ''
          }));
          import("xlsx").then(xlsx => {
            const worksheet = xlsx.utils.json_to_sheet(filtered);
            const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
            const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
            const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });

            const suffix = this.isToggleOn ? '_Evaluated' : '_NotEvaluated';
            saveAs(blob, `Competency_${this.selectedYear}${suffix}.xlsx`);
          });
        }
      });
    }
  }
}
